module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("ACROSS THE MILLENIA")]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whether graced by the grand titles of chirognomony, the study of the overall shape of the hand, or chiromancy, the study of the lines, people have been fascinated by the hand for thousands of years, both as the means by which much of everyday life is made feasible and as a reflection of the inner self.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Though there is little recorded history until the time of Aristotle, it is thought that the ancient Chinese studied the hand as early as the third century BC. In India, soon after this time, hand analysis was recorded in scientific records such as the monumental "), _c('em', [_vm._v("Shastra")]), _vm._v(". Written by Aryan sages, and also known as the Vedic texts, it also included readings of the head, chest and feet. Our early knowledge of Ayurvedic medicine comes from these texts. The popularity of palmistry in the near and middle east also suggests a long history which has been passed down through the Chaldeans, Sumerians and Babylonians.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The ancient Greeks were keen students of the hand, and several sources record that Aristotle found an ancient Arabic treatise on the hand on an altar to Hermes, which he sent to his most distinguished pupil, Alexander the Great.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Anaxagoras, the Greek thinker, propounded that man’s superiority over other animals was due to the ability to "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("use his hands. In his "), _c('em', [_vm._v("Treatise on the Parts of Animals,")]), _vm._v(" Aristotle devotes a section to a criticism of this belief in which he rates man’s overall superior intelligence, which gave him the intellect to use his hands, as a more important fact in man’s superiority. He concludes that the hand is talon, hoof and horn at will. It is the sword and spear or whatever weapon you please. He also discoursed on the importance of nails. Man has them for protection, whilst base animals use them solely for fighting. Aristotle’s thoughts look dubious today, but the fact that the hand was given so much attention shows how important it is in the scheme of things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Romans were interested in hands, along with almost every other possible type of divination. Artemidorus wrote a treatise, now lost, which must have been of considerable importance if it matched the content of his "), _c('em', [_vm._v("Interpretation of Dreams.")]), _vm._v(" Josephus, the Jewish historian, recorded that Julius Caesar was skilled at reading hands and that “it was impossible for any man whose palm Caesar had seen to deceive him in any way. One day "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("a man came to him claiming to be the son of King Herod. Caesar recognised him as an imposter immediately as he had no sign of royalty on his hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The hand appears significantly in the Bible with specific references to palmistry in Proverbs 3:16 ‘Length of days is in her right hand; and in her left hand riches and honour’. In Exodus there is a reference to the hand as symbolising God’s presence and power and it is still the custom for the blessing to be given with the thumb, index and middle fingers raised, evoking the Father, Son and Holy Ghost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The practice of the laying on of hands crosses all faiths and continents, from Native Americans to priests in Nepal.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("However, it was not until the 19th century that palmistry began to be recorded in a systematic way The most influential writers were the French chiromancers, D’Arpentigny and Desbarolles, who laid down the basic rules for classifying hands. D’Arpentigny classified the major types of the hand in 1843, a system still followed today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From China 5000 years ago to the computer age, the hand, with its hills and valleys, roads and streams, provides a map of life’s terrain to guide us to a greater understanding of our inner feelings and potential achievements.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b87e6e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 75
// module chunks = 0